module.exports = __webpack_public_path__ + "static/media/last_page_white_24dp.e807800d.svg";